/**
 * Which nav item the current URL belongs to.
 *
 * Split from SideBar.js for the same reason moduleNav.js was: importing that
 * file pulls in react-router-dom, which CRA's Jest cannot transform. The
 * matcher is the part most worth testing, so it must not live there.
 */

const trimTrailingSlash = (value) =>
  value.length > 1 ? value.replace(/\/+$/, "") : value;

/**
 * True when `path` IS the current page or an ancestor of it.
 *
 * Matching is on whole segments. "/redesign/cases" covers
 * "/redesign/cases/AbC123" but not "/redesign/cases-modern/AbC123" — the
 * trailing slash in the comparison is what forces that boundary, and its
 * absence is a live bug in the old sidebar, which lights CASES on
 * /cases-modern/:caseId today.
 *
 * The descendant half is the whole point: break-in and PAYD were matched by
 * equality, so opening a break-in CASE lit nothing at all — the reader lost
 * any sense of which product they were inside. Claims escaped it only because
 * it had a hand-written startsWith of its own.
 *
 * Trailing slashes are ignored on both sides: React Router normalises them
 * when it matches routes, so /redesign/people/ renders the page and has to
 * light the row. A falsy path never matches — Home has none, and Analytics
 * has its own stripped for clients whose backend does not serve it.
 */
export const isNavPathActive = (pathname, path) => {
  if (!path) return false;
  const current = trimTrailingSlash(String(pathname || ""));
  const target = trimTrailingSlash(String(path));
  return current === target || current.startsWith(`${target}/`);
};

export default isNavPathActive;
